<template>
  <div id="nav">
    <div class="navtop">
      <div class="navtop_b">
        <ul class="navtop_b_left">
          <li>
            <a href="/">首页</a>
          </li>
          <!-- <li>
            <a href="/help.html#/doc/cec13651-6b00-44d1-8ded-a98cc61ed3e0">维修与技术支持</a>
          </li> -->
        </ul>
        <ul class="navtop_b_right">
          <li v-if="!name">
            <a href="/login.html" target="_blank">请登录</a>&nbsp;&nbsp;&nbsp;|
          </li>
          <li v-if="!name">
            <a href="/register.html#/mailregister" target="_blank">注册</a>
            &nbsp;&nbsp;&nbsp;&nbsp;|
          </li>
          <!-- <li v-if="!name">
            <a class="wx" @click.stop="toWechatLogin"><b/> 微信登录</a>&nbsp;&nbsp;&nbsp;&nbsp;|
          </li> -->
          <li v-if="name">
            <a href="/own.html" title="个人中心" target="_blank">
              <b :style="`background:url(${avatar}) no-repeat; background-size: 20px 20px;`" />
              {{ name }}
            </a>
          </li>
          <li v-if="name">
            <a style="cursor: pointer" @click.stop="userLogout">退出</a>
            &nbsp;&nbsp; |
          </li>
          <li>
            <a href="/own.html#/order">我的订单</a>
            &nbsp;&nbsp; |
          </li>
          <li>
            <a href="/help.html#/doc/057c308b-dfb0-4e62-8c34-ed95d45575aa">帮助中心</a>
            &nbsp;&nbsp; |
          </li>
          <li>
            <a href="/cart.html">购物车({{ cartnum }})</a>
          </li>
        </ul>
      </div>
    </div>
    <div class="navbottom">
      <div class="navbottom_logo">
        <img src="~@/assets/images/mall_logo.png" alt="logo">
      </div>
      <div class="navbottom_menu">
        <ul>
          <li class="allcat" @click.stop="closeCat">
            <a>
              <img src="~@/assets/images/all_cat_ui.png">
            </a>
          </li>
          <li>
            <a href="/list.html#/f3fd3027-8bde-492c-9827-eb8b66dbdad5">
              <img src="~@/assets/images/GrguiqzHENWVYHYWyHBM.png">
            </a>
          </li>
          <li>
            <a href="/list.html#/ee2a6b7b-9d37-4df3-8c38-4e26ca87cf67">
              标签定制
            </a>
          </li>
          <li>
            <a href="/list.html#/e49b53cf-0c1c-4494-967a-d125d2d322f0">标签打印机</a>
          </li>
          <li>
            <a href="/list.html#/e32b4cfb-b45c-426e-9f9b-651bf412e17e">移动数据终端</a>
          </li>
          <li>
            <a href="/list.html#/761f26d0-071f-4400-bc02-46edfe892a79">条码扫描器</a>
          </li>
        </ul>
      </div>
      <div class="navbottom_input">
        <!-- <input type="text"> -->
        <el-input
          v-model="searchWord"
          placeholder="搜索"
          prefix-icon="el-icon-search"
          size="small"
          maxlength="20"
          @keyup.enter.native="toSearch"
        />
      </div>
    </div>
    <div
      :style="{ 'height': `${menuHeight}px`, 'borderTop': `${parseInt(menuHeight) ? '1px solid #f9f9f9' : '0px solid #f9f9f9'}` }"
      class="all_cat"
      @mouseleave="closeCat">
      <div ref="menu_content" class="content">
        <ul ref="menu_left" class="menu_left">
          <li
            v-for="(catItem, catKey) in catList"
            :key="catKey"
            @mouseenter="childCatGet(catItem.catId)">
            {{ catItem['catName'] }}
            <icon class="el-icon-arrow-right" />
          </li>
        </ul>
        <ul ref="menu_right" class="menu_right">
          <li v-for="(catItem, catKey) in childCats" :key="catKey">
            <a :href="`/list.html#/${catItem['catId']}`">
              <div><img :src="catItem['catImg']" alt=""></div>
              <p>{{ catItem['catName'] }}</p>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import { Loading } from 'element-ui'
const { PRO_CATS_GET } = require('@/api/mall/pro_cat')
import gsap from 'gsap'
export default {
  name: 'Home',
  data() {
    return {
      searchWord: '',
      showAll: false,
      catList: null,
      childCats: null,
      tweenedNumber: 0
    }
  },
  computed: {
    menuHeight: function() {
      return this.tweenedNumber.toFixed(0)
    },
    ...mapGetters([
      // 头像
      'avatar',
      // 用户名
      'name',
      // 购物车产品数量
      'cartnum'
    ])
  },
  watch: {
    showAll: {
      async handler(newValue, oldValue) {
        // 显示且分类不存在
        if (newValue) {
          // 加载分类
          if (!this.catList) {
            const upLoading = Loading.service({
              lock: true, text: `...`
            })
            await this.catsGetFn({}, 'catList', upLoading)
          }
          const upLoading2 = Loading.service({
            lock: true, text: `...`, target: document.querySelector('.menu_right')
          })
          await this.catsGetFn({ parentId: this.catList[0].catId }, 'childCats', upLoading2)
          gsap.to(this.$data, { duration: 0.2, tweenedNumber: this.$refs.menu_content.offsetHeight })
        }
      },
      deep: true
    }
  },
  methods: {
    closeCat() {
      gsap.to(this.$data, { duration: 0.2, tweenedNumber: 0 })
      this.showAll = !this.showAll
    },
    showAllCat() {
      this.showAll = !this.showAll
    },
    toSearch() {
      if (!this.searchWord || !this.searchWord.trim() || this.searchWord.length < 2) {
        this.$message({ type: 'error', message: '关键字请大于2个字符！' })
        return
      }
      window.location.href = `/list.html#/search/${this.searchWord}`
    },
    // 用户退出
    userLogout() {
      const upLoading = Loading.service({
        lock: true, text: `用户注销中...`
      })
      this.$store.dispatch('user/logout').then(res => {
        // 当前页面为 own.html  cart.html order.html
        const fullPath = window.location.href
        const pagePath = fullPath.slice(0, fullPath.indexOf('#'))
        const pageName = pagePath.slice(pagePath.lastIndexOf('/') + 1)
        if (pageName === 'own.html' || pageName === 'cart.html' || pageName === 'order.html') {
          window.location.href = '/'
        }
        upLoading.close()
      }).catch(e => {
        console.log(e)
        upLoading.close()
      })
    },

    // 小分类加载
    async childCatGet(parentId) {
      const upLoading = Loading.service({
        lock: true, text: `...`, target: document.querySelector('.menu_right')
      })
      await this.catsGetFn({ parentId }, 'childCats', upLoading)
      if (this.$refs.menu_content.offsetHeight > this.menuHeight) {
        gsap.to(this.$data, { duration: 0.2, tweenedNumber: this.$refs.menu_content.offsetHeight })
      }
    },

    async catsGetFn(params, data, upLoading) {
      try {
        const res = await PRO_CATS_GET(params)
        console.log('res:', res)
        this[data] = res.data
        upLoading.close()
      } catch (err) {
        console.log(err)
        upLoading.close()
      }
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/common";
#nav {
  width: 100%;
  //height: 110px;
  margin: 0 auto;
  box-shadow: 0px 15px 10px -15px #ccc;
  position: relative;
  & > .tip {
    width: 100%;
    background: rgb(252, 164, 164);
    color: $dangerColor;
    font-size: 14px;
    line-height: 30px;
    height: 30px;
    text-align: center;
  }
  & > p {
    color: red;
  }
  & > .navtop {
    width: 100%;
    height: 36px;
    background-color: #f9f9f9;
    & > .navtop_b {
      width: 1200px;
      height: 36px;
      line-height: 36px;
      margin: 0 auto;
      & > ul.navtop_b_left {
        list-style-type: none;
        width: 550px;
        height: 36px;
        float: left;
        & > li {
          display: inline-block;
          color: #a4a4a4;
          margin-right: 10px;
          & > a {
            color: #a4a4a4;
            line-height: 24px;
            text-decoration: none;
            font-size: 12px;
          }
        }
      }
      & > ul.navtop_b_right {
        list-style: none;
        width: 500px;
        height: 36px;
        float: right;
        text-align: right;
        font-size: 12px;
        & > li {
          display: inline-block;
          color: #a4a4a4;
          padding: 0 5px;
          & > a {
            color: #a4a4a4;
            line-height: 24px;
            text-decoration: none;
            cursor: pointer;
            font-size: 12px;
            & > b{
                width: 20px;
                height: 24px;
                line-height: 24px;
                display:inline-block;
                vertical-align: middle;
            }
            &.wx{
                & > b{
                  background:url(~@/assets/images/QQ-weixin.png) no-repeat -19px 2px;
                }
            }
          }

        }
      }
    }
  }
  & > .navbottom {
    width: 1200px;
    height: 75px;
    margin: 0 auto;
    & > .navbottom_logo {
      height: 35px;
      float: left;
      margin-top: 18.5px;
      & > img {
        height: 35px;
      }
    }
    & > .navbottom_menu {
      width: 650px;
      height: auto;
      float: left;
      margin-top: 25.5px;
      & > ul {
        list-style-type: none;
        & > li {
          float: left;
          height: 24px;
          width: auto;
          text-align: center;
          margin: 0 10px;
          & > a {
            text-decoration: none;
            font-size: 16px;
            color: #000;
            & > img {
              height: 24px;
              width: auto;
            }
          }
          & > a:hover {
            color: red;
            opacity: 0.9;
          }

          &.allcat{
            position: relative;
            & > .catbox{
              position: absolute;
              display: -webkit-flex; /* Safari */
              justify-content: flex-start;
              flex-direction: row;
              display: flex;
              top: 60px;
              left: 0;
              background: #fff;
              min-height: 188px;
              min-width: 450px;
              box-shadow: 0 0 4px #ddd;
              z-index: 999;
              & > ul.menuLeft{
                width: 210px;
                padding: 10px 0;
                flex-shrink: 0;
                & > li{
                  line-height: 42px;
                  // text-align: left;
                  display: flex;
                  justify-content: space-between;
                  font-size: 16px;
                  padding: 0 20px;
                  color: #222;
                  &:hover{
                    background: #fff;
                    box-shadow: 0 0 1px #ddd;
                    color: #666;
                  }
                  & > icon{
                    // float: right;
                    vertical-align: middle;
                    line-height: 42px;
                  }
                }
              }

              & > ul.menuRight{
                max-width: 990px;
                background: #d22;
                display: -webkit-flex; /* Safari */
                align-content: flex-start;
                flex-direction: row;
                flex-wrap: wrap;
              }
            }
          }
        }
      }
    }
    & > .navbottom_input {
      width: 320px;
      height: 30px;
      float: right;
      margin-top: 22.5px;
      position: relative;
      margin-left: 5px;
      & > .el-input{
        // width: 260px;
        & input{
          // border-color: #ff8486;
          border-radius: 16px;
        }
      }
      & > .el-button{
        width: 50px;
        padding-left:0;
        padding-right:0;
        text-align:center;
      }
      // & > .icon-user {
      //   position: absolute;
      //   right: 0;
      //   z-index: 5;
      //   background-image: url(~@/assets/images/icon_ss.png);
      //   background-repeat: no-repeat;
      //   background-position: 0px 0px;
      //   width: 30px;
      //   height: 30px;
      // }
      // & > input {
      //   width: 320px;
      //   height: 30px;
      //   border-radius: 15px;
      //   background-color: #f0f0f0;
      //   letter-spacing: 1px;
      //   padding-left: 8px;
      //   outline: none;
      //   color: #666;
      // }
    }
  }
  & > .all_cat{
    background: #fff;
    position: absolute;
    top: 111px;
    z-index: 999;
    width: 100%;
    box-shadow: 0 1px 2px #ddd;
    overflow: hidden;
    height: 0;
    & > .content{
      width: 1200px;
      margin: 0 auto;
      padding: 10px 0;
      display: flex;
      justify-content: space-between;
      & > ul.menu_left{
        width: 210px;
        padding: 10px 0;
        flex-shrink: 0;
        & > li{
          line-height: 42px;
          // text-align: left;
          display: flex;
          justify-content: space-between;
          font-size: 16px;
          padding: 0 20px;
          color: #222;
          &:hover{
            background: #fff;
            box-shadow: 0 0 1px #ddd;
            color: #666;
          }
          & > icon{
            // float: right;
            vertical-align: middle;
            line-height: 42px;
          }
        }
      }

      & > ul.menu_right{
        width: 980px;
        display: -webkit-flex; /* Safari */
        align-content: flex-start;
        flex-direction: row;
        flex-wrap: wrap;
        & > li{
          width: 210px;
          padding: 16px 10px;
          & > a{
            display: flex;
            justify-content: space-between;
            & > div{
              width: 52px;
              height: 52px;
              & > img{
                display: inline-block;
                max-width: 100%;
                max-height: 100%;
                width: auto !important;
                height: auto !important;
                vertical-align: middle;
              }
            }
            & > p{
              width: 150px;
              font-size: 16px;
              color: #666;
              line-height: 52px;
            }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Common/nav.vue